/* 08 LEFT - WHITE LINE PREVIEW

   Any airport diagram can be ordered in the White Line style without its own
   variant. The picker ("Style: Original | White Line", rendered by
   sections/08l-product.liquid) swaps the main image for the product's
   White Line preview and the cart line carries  Style: White Line
   (buildItem in 08l-product.liquid). Same variant, same price; Ryan makes the
   print file per order.

   The preview is a real image, made from the airport's PSD by
   ~/Downloads/08-left-whiteline/scripts/whiteline.py and stored on the product
   as metafield custom.whiteline_preview. The section only renders the picker
   when that metafield is set.

   History: 2026-10-19.1 drew the preview in the browser from the 1400px
   Original photo. Ryan: "diagram looks thick" - a small, soft source cannot
   give back thin hairlines, and Gotham cannot be used on the web. Replaced
   the same day by PSD-made images.
*/
(function(){
  var VERSION = '2026-10-19.2';
  var api = { VERSION: VERSION, on: false };
  window.OL_WL = api;

  function init(){
    var box = document.getElementById('olpWl');
    var mainImg = document.querySelector('.olp__frame img');
    if (!box || !mainImg) return;
    var pills = box.querySelectorAll('[data-wl]');
    var note = box.querySelector('.olp__wl-note');
    var wlSrc = box.dataset.wlImg;
    var artBase = base(box.dataset.art);
    var applying = false;

    function base(u){ try{ return new URL(u, location.href).pathname; }catch(e){ return u; } }
    function swap(src, isWl){
      applying = true;
      mainImg.removeAttribute('srcset');
      mainImg.src = src;
      if (isWl) mainImg.setAttribute('data-wl-preview', '1'); else mainImg.removeAttribute('data-wl-preview');
      applying = false;
    }

    // warm the cache so the first tap is instant
    var pre = new Image(); pre.src = wlSrc;

    function set(on){
      api.on = on;
      pills.forEach(function(p){ var s = (p.dataset.wl === '1') === on; p.classList.toggle('is-sel', s); p.setAttribute('aria-pressed', s ? 'true' : 'false'); });
      if (note) note.hidden = !on;
      if (on){
        document.querySelectorAll('.olp__thumb').forEach(function(t){ t.classList.toggle('is-sel', base(t.dataset.full) === artBase); });
        swap(wlSrc, true);
      } else if (mainImg.getAttribute('data-wl-preview') === '1'){
        swap(box.dataset.art, false);
      }
    }
    pills.forEach(function(p){ p.addEventListener('click', function(){ set(p.dataset.wl === '1'); }); });

    /* The section swaps the main image on variant change and thumbnail click.
       If White Line is on and the Original art comes back, show the White
       Line instead; a photo thumbnail is left alone. */
    new MutationObserver(function(){
      if (applying || !api.on) return;
      if (base(mainImg.src) === base(wlSrc)) return;
      mainImg.removeAttribute('data-wl-preview');
      if (base(mainImg.src) === artBase) swap(wlSrc, true);
    }).observe(mainImg, { attributes: true, attributeFilter: ['src'] });

    console.log('[08L white line] ' + VERSION);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
